// The supported production baseline (Safari/iOS 16.4 and evergreen browsers)
// already implements every feature in Next 14's general-purpose client shim.
// Keep this module deliberately empty so those browsers do not parse it again.
module.exports = {};
